import { LanguagePack } from "./index";

const pack: LanguagePack = {
    // for the rest of the languages this should be in form LangNameInEnglish / LangNameInNativeLanguage. E.g.
    // Russian / Русский
    'lang': 'English',

    "button.ok": 'Ok',
    "button.cancel": 'Cancel',
    "button.commit": 'Commit',
    "button.save": 'Save',
    'button.find': 'Find / Show All',
    'button.new': 'New',
    'button.create': 'Create',
    'button.edit': 'Edit',
    'button.edit_short': 'Edit',
    'button.delete': 'Delete',
    'button.apply': 'Apply',
    'button.add': 'Add',
    'button.clone': 'Clone',
    'button.close': 'Close',
    'button.view': 'View',


    'search.title': 'Search',

    'units.min': 'min',
    'units.hours': 'hour |||| hours',

    'column.id': 'Id',
    'column.action': 'Action',

    'misc.info': 'Info',
    'misc.btn_trash_title': 'Delete selected entries',
    'misc.search_results': 'Search results',
    'misc.no_results': 'No results',
    'misc.nothing_searched_msg': 'Nothing searched yet',

    "nav.dashboard": "Dashboard",
    "nav.overview": "Overview",
    "nav.spartan_sense_portal_settings": "Spartan Sense Portal Settings",
    "nav.settings_and_configuration": "Settings & Configuration",
    "nav.timezones": "Timezones",
    "nav.division": "Divisions",
    "nav.fleetAdministration": "Fleet Administration",
    "nav.person": "Persons",
    "nav.user_administration": "User Administration",
    "nav.serviceAccount": "Service Accounts",
    "nav.vehicle": "Vehicles",
    "nav.sensor": "Sensors/Tires",
    "nav.alarms": "Alarms",
    "nav.configure": "Configure",
    "nav.reports": "Reports",
    "nav.canpimanager": "CANPi Manager",
    "nav.registration": "Registration",
    "nav.sign_out": "Sign out",
    "nav.settings": "Settings",
    "nav.signed_in_as": "Signed in as ",
    "division_path.working_on": "Now working on",
    "division_path.change": "change",
    "division_path.switch_to": "Switch to %{name}",
    "division_path.admin_of": "You are administrator of %{name}",
    'dashboard.excess_assignment.title': 'Take Over',
    'dashboard.excess_assignment.message': 'You will be marked as taking action on this alert. The alert will be suspended for:',
    "dashboard.excess_table.column_header.time": "Time",
    "dashboard.excess_table.column_header.vehicle": "Vehicle",
    "dashboard.excess_table.column_header.sensor": "Sensor",
    "dashboard.excess_table.column_header.quantity": "Quantity",
    "dashboard.excess_table.column_header.value": "Value",
    "dashboard.excess_table.column_header.assignee": "Assignee",
    "dashboard.excess_table.buttons.vehicle": "Vehicle",
    "dashboard.excess_table.buttons.sensor": "Sensor",
    "dashboard.excess_table.buttons.data": "Data",
    "dashboard.excess_table.buttons.iamonit": "I'm on it",
	'dashboard.excess_table.del_confirmation_title': 'Discard alerts',
	'dashboard.excess_table.del_confirmation_msg': 'Discarding is irreversible. Continue?',
    "dashboard.summary_table.header": 'Vehicles summary for "%{name}"',
    "dashboard.summary_table.column_header.total": "Total",
    "dashboard.summary_table.column_header.live": "Live",
    "dashboard.summary_table.column_header.dead": "No data",
    "dashboard.summary_table.column_header.green_zone": "Green Zone",
    "dashboard.summary_table.column_header.yellow_zone": "Yellow Zone",
    "dashboard.summary_table.column_header.red_zone": "Red Zone",
    "dashboard.summary_table.column_header.no_levels": "No levels",

    'division.edit_title': 'View/Edit Division',
    'division.create_title': 'Create new division',
    'division.parent_label': 'Parent',
    'division.name_label': 'Name',
    'division.msg_admin_for': 'You are administrator of %{name}',
    'division.btn_switch': 'Switch to',
    'division.validation_err.parent_not_set': 'Please select parent division',
    'division.validation_err.empty_name': 'Please enter division name',

    'person.edit_title': 'View Account',
    'person.create_title': 'Add new person',
    'person.label_division': 'Division',
    'person.label_first_name': 'First name',
    'person.label_last_name': 'Last name',
    'person.label_username': 'Username',
    'person.label_is_administrator': 'is administrator',
    'person.label_password': 'Password',
    'person.label_confirm_password': 'Confirm password',
    'person.label_level': 'Level',
    'person.label_level_user': 'user',
    'person.label_level_administrator': 'administrator',
    'person.del_confirmation_title': 'Delete persons',
    'person.del_confirmation_msg': 'Deleting is irreversible. Continue?',
    'person.validation_err.division_not_set': 'Please select division',
    'person.validation_err.empty_first_name': 'Please enter first name',
    'person.validation_err.empty_username': 'Please enter username',
    'person.validation_err.password_mismatch': `Password copies don't match`,

    'service_account.edit_title': 'Edit service account',
    'service_account.create_title': 'Create new service account',
    'service_account.label_username': 'Username',
    'service_account.label_division': 'Division',
    'service_account.label_server_url': 'Server URL',
    'service_account.label_password': 'Password',
    'service_account.label_import_vehicles': 'import all vehicles',
    'service_account.del_confirmation_title': 'Delete service accounts',
    'service_account.del_confirmation_msg': 'This will also delete all the vehicles registered under selected account(s). This operation is irreversible',
    'service_account.validation_err.division_not_set': 'Please select division',
    'service_account.validation_err.invalid_server_url': 'Please enter a valid server URL',

    'vehicle.edit_title': 'Edit vehicle',
    'vehicle.create_title': 'Create new vehicle',
    'vehicle.label_box_id_source': 'From Box ID',
    'vehicle.label_source': 'Source',
    'vehicle.label_division': 'Division',
    'vehicle.label_box_id': 'Box ID',
    'vehicle.label_service_account': 'Service account',
    'vehicle.label_vehicle': 'Vehicle',
    'vehicle.placeholder_vehicle': 'Choose vehicle on Geotab',
    'vehicle.label_timezone': 'Timezone',
    'vehicle.placeholder_timezone': 'Choose timezone for ALL vehicles',
    'vehicle.label_display': 'Display',
    'vehicle.label_tags': 'Tags',
    'vehicle.label_last_data': 'Last Sensor datetime',
    'vehicle.placeholder_tags': 'Enter a tag',
    'vehicle.prefix_for_tags': 'Add a new tag',
    'vehicle.label_native_title': 'Native title',
    'vehicle.group_actions': 'Group actions',
    'vehicle.no_data_msg': 'No data for selected vehicles',
    'vehicle.btn_show_on_map': 'Show selected vehicles on map',
    'vehicle.del_confirmation_title': 'Delete vehicles',
    'vehicle.del_confirmation_msg': 'Deleting is irreversible. Continue?',
    'vehicle.group_actions.no_actions_placeholder': 'No actions added',
    'vehicle.group_actions.added_actions_title': 'Actions added',
    'vehicle.group_actions.title_select_action': 'Select an action',
    'vehicle.group_actions.action_title_add_tags': 'Add tags',
    'vehicle.group_actions.action_title_remove_tags': 'Remove tags',
    'vehicle.group_actions.action_title_set_timezone': 'Set timezone',
    'vehicle.group_actions.action_title_set_pressure': 'Set pressure levels',
    'vehicle.group_actions.action_title_set_temperature': 'Set temperature levels',
    'vehicle.btn_sensors': 'Sensors',
    'vehicle.msg_import_in_progress': 'Import in progress. It can take a few minutes',
    'vehicle.validation_err.division_not_set': 'Please select division',
    'vehicle.validation_err.invalid_box_id': 'Box ID is not valid',
    'vehicle.validation_err.service_account_not_set': 'Please select service account',
    'vehicle.validation_err.geotab_vehicle_not_set': 'Please select Geotab vehicle',

    'sensor.edit_title': 'Edit sensor',
    'sensor.create_title': 'Add new sensor',
    'sensor.btn_last_24h': 'Last 24h',
    'sensor.btn_yesterday': 'Yesterday',
    'sensor.btn_go': 'Go',
    'sensor.placeholder_from': 'from',
    'sensor.placeholder_to': 'to',
    'sensor.label_vehicle': 'Vehicle',
    'sensor.label_display': 'Display',
    'sensor.label_lifetime': 'Lifetime, h',
    'sensor.label_native_title': 'Native title',
    'sensor.label_sensor': 'Sensor',
    'sensor.label_quantity': 'Quantity',
    'sensor.del_confirmation_title': 'Delete sensors',
    'sensor.del_confirmation_msg': '<b>IMPORTANT</b>:<br /> Both Temperature and Pressure values for ALL checkmarked SensorID’s will be deleted. <br /><b>This operation is irreversible. Continue?',
    'sensor.no_data_msg': 'No data for the selected period',
    'sensor.placeholder_vehicle': 'Choose vehicle',
    'sensor.placeholder_sensor': 'Choose sensor',
    'sensor.validation_err.vehicle_not_set': 'Please select vehicle',
    'sensor.validation_err.sensor_not_set': 'Please select sensor',
    'sensor.validation_err.quantity_not_set': 'Please select quantity',

    'sensors_data.btn_graph': 'Graph',
    'sensors_data.btn_table': 'Table',
    'sensors_data.btn_excel': 'Excel',
    'sensors_data.btn_refresh': 'Refresh',
    'sensors_data.btn_map': 'Map',
    'sensors_data.tooltip_hint': 'Hold Alt to select',
    'sensors_data.label_time': 'Time',

    'levels.all_axles': 'all axles',
    'levels.axle_#': 'axle',
    'levels.axles': 'Axles',
    'levels.baseline': 'Baseline',
    'levels.define_alert_levels': 'define alert levels',
    'levels.red_max': 'Red max',
    'levels.red_min': 'Red min',
    'levels.yellow_max': 'Yellow max',
    'levels.yellow_min': 'Yellow min',

    'settings.title_for': 'Settings (%{name})',
    'settings.title_measure_units': 'Units of measure',
    'settings.title_emails': 'Division Email Notification List',
    'settings.title_personal_settings': 'Personal settings',
    'settings.title_language': 'Interface language',
    'settings.title_change_password': 'Edit account and change password',
    'settings.title_password': 'Password',
    'settings.title_confirm_password': 'Confirm password',
    'settings.validation_err.password_mismatch': `Password copies don't match`,
    'settings.validation_err.password_not_set': `Password cannot be empty`,

    'login.placeholder_username': 'Username',
    'login.placeholder_password': 'Password',
    'login.btn_sign_in': 'Sign in',
    'login.err_no_response': 'Server does not respond',

    'reports.no_reports_message': 'No reports Available'
};

export default pack;


// WEBPACK FOOTER //
// ./translations/lang_en.ts